<ion-content>
  <ion-refresher *ngIf="refresh" slot="fixed" (ionRefresh)="pull($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <div class="rt-page__frame">
    <rt-tip *ngIf="tip" [tip]="tip" variant="strip"></rt-tip>
    <div class="rt-page__body">
      <ng-content></ng-content>
    </div>
    <ng-content select="[rtPageFooter]"></ng-content>
  </div>
</ion-content>
